import React,{Component} from 'react';
import Modal from '../components/UI/modal/Modal';
import Aux from './Aux'

const withErrorHandler = (WrappedComponent, axios)=>{

	return class extends Component{
		constructor(props){
			super(props);
			this.state={
				error: null,
				show: false
			}
		}
		

		componentDidMount(){

			axios.interceptors.request.use(req=>{
				this.setState({error: null, show: false});
				return req;
			}, error => Promise.reject(error))

			axios.interceptors.response.use(response=> response
			,error=>{
				
				this.setState({error: error,show: true});
				return Promise.reject(error);
			})
		}

		errorHandler= () =>{
			this.setState({error: null, show: false})
		}

		render(){
			return (
				<Aux>
					{this.state.error? <Modal show={this.state.show} click={this.errorHandler}>
						{this.state.error.message}
					</Modal>: null}
					
					<WrappedComponent {...this.props} />
				</Aux>
			)

		}
		
		
	}
}

export default withErrorHandler;



// WEBPACK FOOTER //
// ./src/hoc/withErrorHandler.jsx